import one from "../../../images/one.png";
import two from "../../../images/two.png";
import three from "../../../images/three.png";
import four from "../../../images/four.png";
import evaluation from "../../../images/evaluation.png";

export default function Evaluation() {
  return (
    <div className="relative bg-white p-4 sm:p-6 md:p-8 overflow-hidden">
      
      <img
        src={one}
        alt="Laptop Icon"
        className="absolute top-4 left-4 w-12 h-12 sm:w-16 sm:h-16"
      />
      <img
        src={two}
        alt="Backpack Icon"
        className="absolute top-4 right-4 w-12 h-12 sm:w-16 sm:h-16"
      />
      <img
        src={three}
        alt="Globe Icon"
        className="absolute bottom-4 left-4 w-12 h-12 sm:w-16 sm:h-16"
      />
      <img
        src={four}
        alt="Palette Icon"
        className="absolute bottom-4 right-4 w-12 h-12 sm:w-16 sm:h-16"
      />

      <div className="relative z-10 text-center mb-10">
        <h2
          className="text-2xl md:text-7xl font-bold text-blue-600"
          style={{ fontFamily: "Montserrat" }}
        >
          Evaluation Process
        </h2>
      </div>

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0 md:space-x-10 relative z-10 mb-10">
        
        <div className="md:w-1/2 space-y-6 text-center md:text-left px-2">
          <div className="flex items-start space-x-4 justify-center md:justify-start">
            <div>
              <div className="flex items-center justify-center md:justify-start">
                <span className="text-yellow-500 text-2xl mr-3">✔</span>
                <h3
                  className="text-xl font-semibold text-orange-500"
                  style={{ fontFamily: "Montserrat" }}
                >
                  Presentation
                </h3>
              </div>
              <p
                className="w-full max-w-[400px] font-medium text-[17px] mx-auto md:mx-0"
                style={{ fontFamily: "Montserrat" }}
              >
                Shortlisted proposals will be asked to present their ideas,
                clearly defining their concepts.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4 justify-center md:justify-start">
            <div>
              <div className="flex items-center justify-center md:justify-start">
                <span className="text-yellow-500 text-2xl mr-3">✔</span>
                <h3
                  className="text-xl font-semibold text-orange-500"
                  style={{ fontFamily: "Montserrat" }}
                >
                  Interviews
                </h3>
              </div>
              <p
                className="w-full max-w-[400px] font-medium text-[17px] mx-auto md:mx-0"
                style={{ fontFamily: "Montserrat" }}
              >
                Top industry mentors will conduct interviews with the
                shortlisted candidates.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center px-2">
          <img
            src={evaluation}
            alt="Evaluation Illustration"
            className="w-[280px] sm:w-[360px] md:w-[500px] h-auto max-w-full"
          />
        </div>
      </div>
    </div>
  );
}
